class Dynamic_Email_List {
    static path = 'variables/dynamic-email-list';

    constructor(mutator) {
        this.addInput("List's Email", "string,email");
        this.addOutput("List Found", "model,email_list");
        this.addOutput("List Not Found", "");
        this.properties = {modelProperties: window.triggerInfo.models['email_list']}

        this.bgcolor = '#ff7c69';
        this.title = 'Get Email List';
        this.desc = 'Find an email list based on its email.';

    }
}

module.exports = Dynamic_Email_List
